import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setAuthToken } from './api/axiosInstance';

/**
 * Hook to sync Clerk's auth token with axios instance
 * Place this at the app root level to ensure all API calls are authenticated
 */
export function useAuthToken() {
  const { getToken, isSignedIn } = useAuth();

  useEffect(() => {
    const syncToken = async () => {
      if (isSignedIn) {
        const token = await getToken();
        setAuthToken(token);
      } else {
        setAuthToken(null);
      }
    };

    syncToken();
  }, [getToken, isSignedIn]);
}
